import "./styles/global.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { GlobalProvider } from "./context/GlobalContext";
import { ClientProvider } from "./context/Client/ClientContext";

import HomePage from "./Pages/HomePage";
import LandingPage from "./Pages/LandingPage";
import ClientPage from "./Pages/ClientPage";
import Header from "./components/layout/Header";
import IdBillFold from "./components/IdBillFold";

function App() {
  useEffect(() => {
    const clearLocalStorage = () => {
      localStorage.clear();
    };

    window.addEventListener("beforeunload", clearLocalStorage);

    return () => {
      window.removeEventListener("beforeunload", clearLocalStorage);
    };
  }, []);

  return (
    <BrowserRouter>
      <GlobalProvider>
        <ClientProvider>
          <div className="gog-app">
            <Header />

            <main className="gog-main">
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/home" element={<HomePage />} />
                <Route path="/client/:id" element={<ClientPage />} />
                <Route path="/idbillfold" element={<IdBillFold />} />
              </Routes>
            </main>
          </div>
        </ClientProvider>
      </GlobalProvider>
    </BrowserRouter>
  );
}

export default App;